import type { ReactNode } from 'react';

/**
 * brand/components/StageBadge: five colour roles, and the label always names the state.
 * new = Iris tint, neutral = grey, pending = amber, funded = mint, declined = red.
 */
export type BadgeRole = 'new' | 'neutral' | 'pending' | 'funded' | 'declined';

export function Badge({
  role,
  dot = false,
  children,
  testId,
}: {
  role: BadgeRole;
  dot?: boolean;
  children: ReactNode;
  testId?: string;
}) {
  return (
    <span className={`fl-badge fl-badge--${role}`} data-testid={testId}>
      {dot ? <span className="fl-badge__dot" aria-hidden /> : null}
      {children}
    </span>
  );
}
